<mat-form-field>
    <mat-label>Division</mat-label>
    <mat-select [(ngModel)]="selectedDivisionIds" (openedChange)="onDivisionDropdownOpenChange($event)" [disabled]="availableDivisionsSignal().length < 2" multiple >
        @for (division of availableDivisionsSignal(); track $index) {
            <mat-option [value]="division.id">{{ division.divisionCode }}</mat-option>
        }
    </mat-select>
</mat-form-field>

<div class="counts-container">
    <div class="count-item">
        <r1-compass-app-recommendations-count [selectedDivisionIds]="selectedDivisionIdsSignal()" [actionType]="'create'" />
    </div>
    <div class="count-item">
        <r1-compass-app-recommendations-count [selectedDivisionIds]="selectedDivisionIdsSignal()" [actionType]="'update'"/>
    </div>
</div>
<div class="activity-summary-container">
    <r1-compass-app-play-activity [selectedDivisionIds]="selectedDivisionIdsSignal()" />
</div>
